import React, {useEffect, useState} from 'react';
import {authSteps} from "./authSteps";
import PropTypes from "prop-types";
import Checkbox from "./Checkbox";
import PhoneField from "./PhoneField";

PhoneWaiting.propTypes = {
    rootForm: PropTypes.object,
    phone: PropTypes.string,
};


function PhoneWaiting(props) {
    return (
        <div className={"mb-4 justify-center " }>
            <div className={(props.isChangePhone ? "" : "max-w-xs")}>
                <div>
                    <div className="form-group relative mb-4 max-w-xs">
                        <div>
                            <label className="text-xs font-normal mb-2 text-textLight dark:text-textDarkLightGray"
                                   htmlFor="smsauth-phone">
                                <span className="starrequired text-light-red md:text-hover-red">* </span>
                                Номер телефона
                            </label>
                            <PhoneField rootForm={props.rootForm} phone={props.phone}/>
                        </div>
                    </div>

                    <Checkbox isChangePhone={props.isChangePhone}/>
                </div>
            </div>
        </div>
    );
}

export default PhoneWaiting;